var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMinimizeBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "10px",
    viewBox: "0 0 32 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_minimize") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "44_My-playlist",
    transform: "translate(-236, -885)",
    fill: "#2363F7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(230, 868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_minimize",
    transform: "translate(6, 17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.86781,4.68115121 L9.32246129,0.158108357 C9.15918295,-0.0316150299 8.87223494,-0.0537319337 8.68157428,0.108782608 C8.49091361,0.271258281 8.46868745,0.55679567 8.63200485,0.746519057 C8.64723895,0.764204806 8.66380116,0.780724462 8.68157428,0.795844805 L12.4496712,4.54996571 L0.454523149,4.54996571 C0.203511998,4.54996571 0,4.75247725 0,5.00229332 C0,5.25210938 0.203511998,5.45458205 0.454523149,5.45458205 L12.4496712,5.45458205 L8.68157428,9.20415519 C8.49091361,9.36663087 8.46868745,9.65216826 8.63200485,9.84189164 C8.79532225,10.031615 9.0822312,10.0537319 9.27289186,9.89121739 C9.29066499,9.87605818 9.30726625,9.85957739 9.32246129,9.84189164 L13.867849,5.31884879 C14.0440568,5.14249661 14.0440568,4.85758113 13.86781,4.68115121 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.86781,4.68115121 L27.3224613,0.158108357 C27.159183,-0.0316150299 26.8722349,-0.0537319337 26.6815743,0.108782608 C26.4909136,0.271258281 26.4686874,0.55679567 26.6320048,0.746519057 C26.647239,0.764204806 26.6638012,0.780724462 26.6815743,0.795844805 L30.4496712,4.54996571 L18.4545231,4.54996571 C18.203512,4.54996571 18,4.75247725 18,5.00229332 C18,5.25210938 18.203512,5.45458205 18.4545231,5.45458205 L30.4496712,5.45458205 L26.6815743,9.20415519 C26.4909136,9.36663087 26.4686874,9.65216826 26.6320048,9.84189164 C26.7953223,10.031615 27.0822312,10.0537319 27.2728919,9.89121739 C27.290665,9.87605818 27.3072663,9.85957739 27.3224613,9.84189164 L31.867849,5.31884879 C32.0440568,5.14249661 32.0440568,4.85758113 31.86781,4.68115121 Z",
    id: "Path",
    transform: "translate(25, 5) scale(-1, 1) translate(-25, -5)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMinimizeBlue);
export default __webpack_public_path__ + "static/media/ic_minimize_blue.d3d09763894b863a74d1f7f37fb2148a.svg";
export { ForwardRef as ReactComponent };